import React from "react";

const Slash = React.memo(() => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            // eslint-disable-next-line react/no-unknown-property
            stroke-width="2"
            // eslint-disable-next-line react/no-unknown-property
            stroke-linecap="round"
            // eslint-disable-next-line react/no-unknown-property
            stroke-linejoin="round"
        >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
        </svg>
    );
});

export default Slash;
